import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';
function initSwiper(selector) {
    if (!selector) {
        return false;
    }
    return new Swiper(selector, {
        spaceBetween: 24,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        modules: [Navigation, EffectFade],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}
export const initBlogHeroSlider = () => {
    new Swiper('.js-blog-hero-slider', {
        modules: [Autoplay, Pagination],
        slidesPerView: 1,
        loop: true,
        autoHeight: true,
        pagination: {
            el: '.js-blog-hero-pagination',
            clickable: true,
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
    });
};
const Sliders = { initSwiper, initBlogHeroSlider };
export default Sliders;
